var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    { attrs: { "label-width": "150px" } },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "客户编码" } },
                [
                  _c("TextEllipsis", {
                    attrs: { text: _vm.basicInfo.clientCode },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "客户名称" } },
                [
                  _c("TextEllipsis", {
                    attrs: { text: _vm.basicInfo.clientName },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "客户类型" } },
                [
                  _c("TextEllipsis", {
                    attrs: { text: _vm.basicInfo.clientTypeName },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "提交时间" } },
                [
                  _c("TextEllipsis", {
                    attrs: { text: _vm.basicInfo.createDateAll },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "人员姓名" } },
                [
                  _c("TextEllipsis", {
                    attrs: { text: _vm.basicInfo.visitRealName },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "职位名称" } },
                [
                  _c("TextEllipsis", {
                    attrs: { text: _vm.basicInfo.visitPosName },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "所属组织" } },
                [
                  _c("TextEllipsis", {
                    attrs: { text: _vm.basicInfo.visitOrgName },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }